import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert } from '@components'
import { SettingsSubPageLayout } from '@pages/SettingsPage/components/SettingsSubPageLayout'
import { PermissionSet, usePermission, usePermissionsLoaded } from '@root/context'
import { useQueryParam, useQueryParams } from '@hooks'
import { BusinessProfileSection } from './BusinessProfileSection'
import { LucaBrandHeading, LucaPrivateBadge } from './LucaBrandHeading'
import { LucaPageContent, SessionGate, useLucaWidgetSession } from './shared'

export const LucaSettingsPage: React.FC = () => {
  const [t] = useTranslation()
  const canViewBusinessTab = usePermission(PermissionSet.ADMIN)
  const permissionsLoaded = usePermissionsLoaded()
  const [, setQueryParams] = useQueryParams()
  const [tab] = useQueryParam('tab')
  const { slug, session, sessionLoading, ready } = useLucaWidgetSession()
  const shouldUseConnectionsPage =
    tab === 'connectors' || (permissionsLoaded && !canViewBusinessTab)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const oauthReturn = params.has('mcp_connected') || params.has('mcp_error')
    if (oauthReturn || shouldUseConnectionsPage) {
      setQueryParams({ page: 'luca-connections', tab: undefined })
    }
  }, [setQueryParams, shouldUseConnectionsPage])

  if (shouldUseConnectionsPage) {
    return null
  }

  return (
    <SettingsSubPageLayout
      title={
        <LucaBrandHeading
          badge={<LucaPrivateBadge>{t('lucaSettings.hero.badge')}</LucaPrivateBadge>}
        >
          {t('lucaSettings.title')}
        </LucaBrandHeading>
      }
    >
      <LucaPageContent>
        <Alert
          type="info"
          title={t('lucaSettings.hero.title')}
          description={t('lucaSettings.hero.body')}
        />

        {!ready ? (
          <SessionGate loading={sessionLoading} hasBusiness={Boolean(slug)} />
        ) : (
          <BusinessProfileSection key={slug} session={session} ready={ready} slug={slug} />
        )}
      </LucaPageContent>
    </SettingsSubPageLayout>
  )
}

export default LucaSettingsPage
